// Registry of in-flight memo save (PUT) requests per chapter. Re-entering a
// chapter fetches memo content over REST; awaiting the pending save first
// guarantees read-after-write within the session (a flushed autosave fired on
// navigation would otherwise race the re-entry GET and serve stale content).
const pendingSaves = new Map<string, Promise<unknown>>();

const saveKey = (projectId: string, chapterId: string) => `${projectId}-${chapterId}`;

export const trackMemoSave = <T>(projectId: string, chapterId: string, save: Promise<T>): Promise<T> => {
  const key = saveKey(projectId, chapterId);
  const entry: Promise<void> = save
    .catch(() => undefined)
    .then(() => {
      if (pendingSaves.get(key) === entry) pendingSaves.delete(key);
    });
  pendingSaves.set(key, entry);
  return save;
};

// Awaits only the save pending at call time (not saves that start during the
// wait) so a continuously-editing session can never stall the caller.
export const waitForPendingMemoSave = async (projectId: string, chapterId: string) => {
  const pending = pendingSaves.get(saveKey(projectId, chapterId));
  if (pending) await pending;
};
